/* eslint-disable import/no-internal-modules */
import Icon from '@insided/deprecated-preact-components/assets'
import SimplePanel from '@insided/deprecated-control/ui-components/SimplePanel'
import TextField from '@insided/deprecated-preact-components/design-system-components/text-field'

interface Props {
    name: string
    description: string
    onNameChange: (value: string) => void
    onDescriptionChange: (value: string) => void
}

const SEOPanel = ({ name, description, onNameChange, onDescriptionChange }: Props) => (
  <SimplePanel className='custom-pages__seo-panel' image={<Icon icon='edit' width={30} height={30} color='#2B3346' />}>
    <div className='custom-page__seo'><h5>SEO</h5></div>
    <p>Help users find your page easily with the right search tags and configurations.!!</p>
    <TextField
      defaultValue={name}
      isInline={false}
      size='fullWidth'
      name='custom_page_meta-name'
      label='Meta page name'
      ariaLabel='Page Name'
      id='custom_page_meta-name'
      onChange={(e) => onNameChange(e)}
    />
    <TextField
      defaultValue={description}
      isInline={false}
      size='fullWidth'
      name='custom_page_meta-description'
      label='Meta page description'
      ariaLabel='Meta page description'
      id='custom_page_meta-description'
      onChange={(e) => onDescriptionChange(e)}
    />
  </SimplePanel>)

export default SEOPanel
